import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CurrentSessionData } from "src/model/class/general classes/current-session-data";
import { GenericUserData } from "src/model/interface/generic-user-data";

/**Return entire feature "user" from state manager;
 *
 * NOTE: this should be used as PRE-EXISTENT FALLBACK for following cases:
 * * Contexts "mixed" where we can be in BIGStudio3 OR DigitalPlace
 * * Contexts where we can be ONLY in "BIGStudio3"
 * * As "main" selector for entire feature.
 * */
export const currentUserData =
  createFeatureSelector<Readonly<GenericUserData>>("user");

//Return if current user (either or "currentUser") is authenticated
export const isUserAuthenticated = createSelector(
  currentUserData,
  (currentUserData: GenericUserData) => {
    return !!currentUserData?.currentUser?.accessToken;
  }
);
